export function group(fieldGroup, items) {
  let groupItemList = [];
  let arrayGroupField;
  if (!fieldGroup) {
    groupItemList = items;
  } else {
    arrayGroupField = fieldGroup.split(",");
  }

  let arrayValue = new Set();

  if (fieldGroup) {
    items.forEach((item) => {
      let valueField = "";
      arrayGroupField.forEach((fieldToGroup, index) => {
        const findField = item.fields.find((field) => field.field_id == fieldToGroup);
        if (findField) {
          valueField += findField.field_value;
        }
        if (arrayGroupField.length - 1 == index) {
          let itemUnics = findUniqItem(valueField);
          if (itemUnics) {
            groupItemList.push(item);
          }
        }
      });
    });
  }

  // send field value and check if it's unique
  function findUniqItem(value) {
    const uniqValue = !arrayValue.has(value);
    if (uniqValue) {
      arrayValue.add(value);
    }
    return uniqValue;
  }

  return groupItemList
  
}
